/**
 * Simple JS implementation of bg parallax, but should convert to pure
 * CSS based solution: https://keithclark.co.uk/articles/pure-css-parallax-websites/
 */
class ParallaxImage {
    constructor(containerElm) {
        this.container = containerElm
        this.image = containerElm.querySelector('img')
        this.applyEffect = false
        this.formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,      
            maximumFractionDigits: 6,
         });
    }

       
    /**
     * Get the pixel positions of an element relative to the document.
     * https://stackoverflow.com/questions/5598743/finding-elements-position-relative-to-the-document#answer-26230989
     * 
     * @param {*} el 
     * @returns 
     */
     static getOffsets(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft =
                window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft, bottom: rect.top - scrollTop + el.offsetHeight }
    }

    applyParallaxEffect(windowScrollPos) {
        let imageOffsets = ParallaxImage.getOffsets(this.image)
        let top = this.container.getBoundingClientRect().top
        let bottom = this.container.getBoundingClientRect().bottom
        
        let diff = windowScrollPos - imageOffsets.top
        
        if (bottom > 0 && top < 0) {
            this.applyEffect = true
            var imgPos = this.formatter.format(diff / 1.8) + 'px'
            this.image.setAttribute(
                'style',
                'transform: translateY(' + imgPos + ');'
            )
        } else {
            // if image is offscreen
            if (this.applyEffect) {
                this.image.setAttribute('style', 'transform: translateY(0px);')
                this.applyEffect = false
            }
        }
    }
}

const initAll = () => {
    // initialize parallax image effect
    let parallaxImages = []
    let parallaxImageContainers = document.querySelectorAll('.parallax')
    parallaxImageContainers.forEach((container) => {
        parallaxImages.push(new ParallaxImage(container))
    })

    window.addEventListener('scroll', () => {
        parallaxImages.forEach((image) => {
            image.applyParallaxEffect(window.pageYOffset)
        })
    })
}

export default initAll
